import { useEffect, useState } from "react";
import { useScreenContext } from "../Layout";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./Loading.css";
import { useTranslation } from "react-i18next";

function Loading() {
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();
  const [progress, setProgress] = useState(0);

  setTimeout(() => {
    if (progress === 100) {
      setScreenData(() => ({
        ...screenData,
        submitLabel: t("layout.cta_continue"),
      }));
      return;
    }
    setProgress(progress + 2);
  }, 120);

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: false,
      nextPath: "loading-result",
      progress: 84,
    }));
  }, []);

  return (
    <div>
      <div className="mx-auto max-w-sm px-20">
        <CircularProgressbar
          value={progress}
          text={`${progress}%`}
          styles={buildStyles({
            pathColor: "#1A56DB",
            textColor: "#666",
            trailColor: "#d6d6d6",
            backgroundColor: "#3e98c7",
          })}
        />
      </div>

      <h1 className="text-gray-900md:text-4xl my-5 text-2xl font-bold tracking-tight">
        {t("loading.headline")}
      </h1>

      <div className="mx-auto max-w-sm text-left font-light">
        <p className="fadein-1 pb-1">{t("loading.item_1")}</p>
        <p className="fadein-2 pb-1">{t("loading.item_2")}</p>
        <p className="fadein-3 pb-1">{t("loading.item_3")}</p>
        <p className="fadein-4 pb-1">{t("loading.item_4")}</p>
        <p className="fadein-5 pb-1">{t("loading.item_5")}</p>
      </div>
    </div>
  );
}

export default Loading;
